import React, { Suspense } from "react";
import { LoadingSpinner } from "src/components/ui/loading-spinner";

const RootlyIntegration = React.lazy(() => import("./RootlyIntegration"));

interface RootlyIntegrationProps {
  isOpen: boolean;
  onClose: () => void;
  onRefetch?: () => void;
  brandTheme?: string | null;
}

export default function RootlyIntegrationLazy(props: RootlyIntegrationProps) {
  return (
    <Suspense fallback={<div className="flex justify-center p-4"><LoadingSpinner /></div>}>
      <RootlyIntegration {...props} />
    </Suspense>
  );
}
